/**
 * Social Icons
 */
/* tslint:disable:max-line-length */
import * as React from 'react';
import * as BEM from 'react-bem-helper';

function IconWrapper({ children, className, id }) {
  const classes = new BEM('icon');
  return <div {...classes('', ['social', id], className) }>{children}</div>;
}

export function IconFacebook({ className = '' }) {
  return (
    <IconWrapper id="facebook" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path fill="#3c5a99" d="M22.8 24c.6 0 1.1-.5 1.1-1.1V5.1c0-.6-.5-1.1-1.1-1.1H5.1C4.5 4 4 4.5 4 5.1v17.8c0 .6.5 1.1 1.1 1.1h17.7z" />
        <path fill="#fefefe" d="M17.9 24v-7.7h2.5l.4-3h-2.9v-1.9c0-.9.2-1.5 1.4-1.5h1.5V7.2c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.4-3.7 4v2.2h-2.5v3h2.5V24h3z" />
      </svg>
    </IconWrapper>
  );
}
export function IconGoogle({ className = '' }) {
  return (
    <IconWrapper id="google" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path fill="#fbbc05" d="M8 14c0-.6.1-1.3.3-1.9L5 9.6c-.6 1.3-1 2.8-1 4.4s.4 3.1 1 4.4l3.3-2.6c-.2-.5-.3-1.2-.3-1.8z" />
        <path fill="#ea4335" d="M5 9.6l3.3 2.6c.8-2.4 2.9-4.1 5.5-4.1 1.4 0 2.6.5 3.6 1.3l2.9-2.9C18.6 5 16.3 4 13.8 4 10 4 6.6 6.3 5 9.6z" />
        <path fill="#34a853" d="M17.1 19c-.9.6-2 .9-3.3.9-2.6 0-4.8-1.7-5.5-4.1L5 18.4c1.6 3.3 4.9 5.6 8.8 5.6 3 0 4.8-1 6.4-2.5-.1-.1-3.1-2.5-3.1-2.5z" />
        <path fill="#4285f4" d="M20.2 21.5c.4-.4.9-.9 1.2-1.4.2-.3.3-.5.5-.8.1-.3.3-.5.4-.8v-.1c.1-.3.2-.5.3-.8 0-.1 0-.1.1-.2.1-.3.1-.5.2-.8 0-.1 0-.2.1-.2.1-.3.1-.6.1-.8v-.3c0-.4.1-.8.1-1.2 0-.6-.1-1.2-.2-1.8h-9.2V16h5.3l-.3.9s0 .1-.1.1c-.1.2-.2.5-.4.7v.1c-.2.2-.3.4-.5.6-.2.2-.5.4-.7.6l3.1 2.5z" />
      </svg>
    </IconWrapper>
  );
}
export function IconSpotify({ className = '' }) {
  return (
    <IconWrapper id="spotify" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path fill="#1ed660" d="M12.2 16.1c2.4 0 4.5.6 6.4 1.7.3.2.4.3.4.7 0 .4-.3.7-.7.7-.2 0-.3-.1-.5-.2-1.6-1-3.6-1.5-5.7-1.5-1.2 0-2.4.2-3.5.4 0 .1-.2.1-.4.1-.4 0-.7-.3-.7-.7 0-.5.3-.7.6-.8 1.4-.2 2.7-.4 4.1-.4m-.1-3.6c2.9 0 5.6.7 7.8 2 .4.2.5.5.5.9 0 .5-.4.9-.9.9-.2 0-.4-.1-.5-.2-1.8-1.1-4.3-1.8-7-1.8-1.4 0-2.6.2-3.6.5-.2.1-.3.1-.5.1-.5 0-.9-.4-.9-.9s.2-.8.7-.9c1.3-.3 2.5-.6 4.4-.6m.2-3.8c3.2 0 6.6.7 9.1 2.1.3.2.6.5.6 1 0 .6-.5 1-1 1-.2 0-.4-.1-.6-.2-2-1.2-5.1-1.9-8-1.9-1.5 0-3 .2-4.4.5-.2 0-.4.1-.6.1-.6 0-1-.5-1-1.1 0-.6.4-.9.8-1.1 1.5-.1 3.2-.4 5.1-.4M13.9 3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11S20 3 13.9 3" />
      </svg>
    </IconWrapper>
  );
}
export function IconTwitter({ className = '' }) {
  return (
    <IconWrapper id="twitter" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path d="M25 7.92a8.2 8.2 0 0 1-2.36.65 4.12 4.12 0 0 0 1.8-2.27 8.22 8.22 0 0 1-2.61 1 4.11 4.11 0 0 0-7 3.74 11.65 11.65 0 0 1-8.44-4.29 4.11 4.11 0 0 0 1.27 5.48 4.09 4.09 0 0 1-1.86-.51v.05a4.11 4.11 0 0 0 3.29 4 4.11 4.11 0 0 1-1.85.07 4.11 4.11 0 0 0 3.83 2.85A8.23 8.23 0 0 1 6 20.47a8.35 8.35 0 0 1-1-.06 11.67 11.67 0 0 0 18-9.83v-.53a8.34 8.34 0 0 0 2-2.13z" fill="#55acee" />
      </svg>
    </IconWrapper>
  );
}
export function IconApple({ className = '' }) {
  return (
    <IconWrapper id="apple" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path d="M22.42 17.66c-.12.33-.23.63-.35.93A11.88 11.88 0 0 1 21 20.52a9.53 9.53 0 0 1-1.39 1.67 2.67 2.67 0 0 1-1.78.78 4.46 4.46 0 0 1-1.64-.39 4.69 4.69 0 0 0-1.77-.39 4.85 4.85 0 0 0-1.82.39A4.79 4.79 0 0 1 11 23a2.57 2.57 0 0 1-1.82-.8 10.1 10.1 0 0 1-1.45-1.74 12 12 0 0 1-1.54-3 11.12 11.12 0 0 1-.64-3.63 6.64 6.64 0 0 1 .87-3.46 5.09 5.09 0 0 1 1.85-1.89 4.84 4.84 0 0 1 2.46-.7 5.78 5.78 0 0 1 1.91.44 6.15 6.15 0 0 0 1.52.44 9.15 9.15 0 0 0 1.67-.53 5.45 5.45 0 0 1 2.27-.4 4.86 4.86 0 0 1 3.79 2 4.21 4.21 0 0 0-2.23 3.83 4.19 4.19 0 0 0 1.39 3.18 4.28 4.28 0 0 0 1.37.92zM18.19 3v.4a4.28 4.28 0 0 1-1.1 2.8A3.73 3.73 0 0 1 14 7.73v-.38a4.43 4.43 0 0 1 1.16-2.83 4.57 4.57 0 0 1 1.41-1.06A4.25 4.25 0 0 1 18.19 3z" />
      </svg>
    </IconWrapper>
  );
}
export function IconInstagram({ className = '' }) {
  return (
    <IconWrapper id="instagram" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <path d="M14.08 5.88c2.67 0 3 0 4 .06a5.53 5.53 0 0 1 1.92.34 3.31 3.31 0 0 1 1.9 1.9 5.53 5.53 0 0 1 .32 1.82c0 1.05.06 1.37.06 4s0 3-.06 4a5.53 5.53 0 0 1-.34 2 3.31 3.31 0 0 1-1.9 1.9 5.53 5.53 0 0 1-1.86.34c-1.05 0-1.37.06-4 .06s-3 0-4-.06a5.53 5.53 0 0 1-1.86-.34A3.31 3.31 0 0 1 6.28 20a5.53 5.53 0 0 1-.34-1.86c0-1.05-.06-1.37-.06-4s0-3 .06-4a5.53 5.53 0 0 1 .34-1.86 3.31 3.31 0 0 1 1.9-1.9A5.53 5.53 0 0 1 10 5.94c1.05 0 1.37-.06 4-.06m0-1.8c-2.72 0-3.06 0-4.12.06a7.34 7.34 0 0 0-2.43.46A5.11 5.11 0 0 0 4.6 7.53 7.34 7.34 0 0 0 4.14 10c0 1.07-.06 1.41-.06 4.12s0 3.06.06 4.12a7.34 7.34 0 0 0 .46 2.43 5.11 5.11 0 0 0 2.92 2.92A7.34 7.34 0 0 0 10 24c1.07 0 1.41.06 4.12.06s3.06 0 4.12-.06a7.34 7.34 0 0 0 2.43-.46 5.11 5.11 0 0 0 2.92-2.92A7.34 7.34 0 0 0 24 18.2c0-1.07.06-1.41.06-4.12S24.07 11 24 10a7.34 7.34 0 0 0-.46-2.43 5.11 5.11 0 0 0-2.91-2.97 7.34 7.34 0 0 0-2.43-.46c-1.07 0-1.41-.06-4.12-.06z" />
        <path d="M14.08 8.94a5.14 5.14 0 1 0 5.14 5.14 5.14 5.14 0 0 0-5.14-5.14zm0 8.47a3.33 3.33 0 1 1 3.33-3.33 3.33 3.33 0 0 1-3.33 3.33z" />
        <circle cx="19.42" cy="8.74" r="1.2" />
      </svg>
    </IconWrapper>
  );
}
export function IconBandCamp({ className = '' }) {
  return (
    <IconWrapper id="bandcamp" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <circle cx="14" cy="14" r="11" fill="#60909a" />
        <path fill="#fff" fillRule="evenodd" d="M16.14 17.46H8.11l3.75-6.92h8.03l-3.75 6.92" />
      </svg>
    </IconWrapper>
  );
}
export function IconSoundCloud({ className = '' }) {
  return (
    <IconWrapper id="soundcloud" className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <defs>
          <linearGradient id="a" x1="14" y1="47.21" x2="14" y2="36.79" gradientTransform="matrix(1 0 0 -1 0 56)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f79810" />
            <stop offset="1" stopColor="#f8310e" />
          </linearGradient>
        </defs>
        <path d="M2.27 15a.1.1 0 0 0-.1.09L2 16.45l.18 1.31a.1.1 0 0 0 .1.09.1.1 0 0 0 .1-.09l.21-1.31-.21-1.33a.1.1 0 0 0-.11-.12zm1-.73a.1.1 0 0 0-.2 0l-.24 2.16.24 2.11a.1.1 0 0 0 .2 0l.27-2.11zm3.72-2a.19.19 0 0 0-.18.18l-.19 4L6.8 19a.18.18 0 0 0 .36 0l.21-2.56-.21-4a.19.19 0 0 0-.16-.13zm-1.94 1.41a.14.14 0 0 0-.14.14l-.21 2.63.21 2.55a.14.14 0 0 0 .28 0l.24-2.54-.24-2.63a.14.14 0 0 0-.14-.15zm3.88 5.51a.23.23 0 0 0 .22-.19l.18-2.52-.18-5.28a.22.22 0 0 0-.45 0l-.16 5.28.17 2.52a.22.22 0 0 0 .22.19zm4 0a.31.31 0 0 0 .3-.3l.13-2.45-.13-6.1a.3.3 0 0 0-.61 0l-.11 6.1.11 2.45a.31.31 0 0 0 .32.31zm-2 0a.27.27 0 0 0 .26-.26l.16-2.48-.16-5.32a.26.26 0 0 0-.53 0l-.14 5.32.14 2.48a.26.26 0 0 0 .26.27zM6 19.17a.16.16 0 0 0 .17-.17l.23-2.56L6.17 14a.16.16 0 0 0-.32 0l-.2 2.44.2 2.56a.16.16 0 0 0 .15.17zM4.1 19a.12.12 0 0 0 .12-.12l.25-2.46-.25-2.56a.12.12 0 0 0-.12-.12.12.12 0 0 0-.12.12l-.22 2.56.24 2.49a.12.12 0 0 0 .1.09zm7.82-8a.28.28 0 0 0-.28.28l-.13 5.12.13 2.47a.28.28 0 0 0 .57 0l.14-2.47-.14-5.12a.28.28 0 0 0-.29-.28zM8 19.2a.21.21 0 0 0 .2-.2l.2-2.55-.2-4.87a.2.2 0 0 0-.4 0l-.18 4.87.13 2.55a.2.2 0 0 0 .25.2zm2.16-.2l.17-2.5-.17-5.5a.24.24 0 0 0-.49 0l-.15 5.46.16 2.54a.24.24 0 0 0 .49 0zM23 13.31a3 3 0 0 0-1.14.23 5.21 5.21 0 0 0-5.19-4.75 5.28 5.28 0 0 0-1.89.35c-.22.09-.28.17-.28.35v9.37a.36.36 0 0 0 .32.35H23a3 3 0 0 0 0-5.9zm-9.06-3.83a.33.33 0 0 0-.33.32l-.13 6.65.13 2.41a.33.33 0 0 0 .65 0l.14-2.41-.13-6.65a.33.33 0 0 0-.33-.32z" fill="url(#a)" />
      </svg>
    </IconWrapper>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/images/Icon/social-icons.tsx